export default __webpack_public_path__ + "static/media/halloween-logo.b23a35a2.svg";